module.exports = __webpack_public_path__ + "img/后援协力部.7c7df271.jpg";